import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const LD = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 25' {...rest}>
    {type === 'stroke' ? (
      <>
        <path
          d='M2.844 6.416a3.25 3.25 0 0 1 3.25-3.25h12a3.25 3.25 0 0 1 3.25 3.25v12a3.25 3.25 0 0 1-3.25 3.25h-12a3.25 3.25 0 0 1-3.25-3.25z'
          stroke='currentColor'
          strokeWidth='1.5'
        />
        <path
          d='M6.866 15.916q-.38 0-.577-.198-.195-.208-.195-.584V9.698q0-.376.195-.574.196-.208.567-.208.753 0 .753.782v4.921h2.62q.657 0 .656.643 0 .654-.655.654z'
          fill='currentColor'
        />
        <path
          d='M12.49 15.916q-.79 0-.791-.802V9.738q0-.802.792-.802h1.907q1.76 0 2.728.91.968.902.968 2.575t-.968 2.584q-.969.91-2.728.911zm.724-1.257h1.096q2.2 0 2.2-2.238 0-2.228-2.2-2.228h-1.096z'
          fill='currentColor'
        />
      </>
    ) : (
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M6.094 2.416a4 4 0 0 0-4 4v12a4 4 0 0 0 4 4h12a4 4 0 0 0 4-4v-12a4 4 0 0 0-4-4zm.195 13.302q.196.198.577.198h3.364q.655 0 .655-.654 0-.643-.655-.643H7.61v-4.92q0-.783-.754-.783-.37 0-.567.208-.195.198-.195.574v5.436q0 .375.195.584m5.41-.604q0 .802.792.802h1.907q1.76 0 2.728-.91.968-.912.968-2.585t-.968-2.574q-.969-.912-2.728-.911H12.49q-.792 0-.792.802zm2.61-.455h-1.094v-4.466h1.095q2.2 0 2.2 2.228 0 2.238-2.2 2.238'
        fill='currentColor'
      />
    )}
  </IconBase>
);
